import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { GlobalEventMangerService } from '../global-event-manger.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-activefreetrial',
  templateUrl: './activefreetrial.component.html',
  styleUrls: ['./activefreetrial.component.css'],
  providers: [Modal]
})
export class ActivefreetrialComponent implements OnInit {
	public freetrial: any = {};
	public signupPlanList:any[] = [];;
	public token: string;
	public _id: string;
	busy: Subscription;
  
	constructor(private userService: UserService, private toastr: ToastrService, private router: Router, vcRef: ViewContainerRef, public modal: Modal, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) { 
	
		var currentUser = this.localStorageService.getData("currentUserToken");;
        this.token =  currentUser.data.user_token;
	    let userDetails = this.localStorageService.getData("currentUser");
        this._id = userDetails._id;
	
	}

	ngOnInit() {
		this.getSignUpPlan();
	}
	// Get Sign up Plan
	getSignUpPlan() {
		var data = {
			token:this.token
		}
	let responseData = <any>{};
	this.busy = this.userService.getAllSignupPlan(data).subscribe(	
	   response => {
			responseData = response;
			this.signupPlanList  = responseData.data;
	   },
	   error => {
			responseData = error;
			console.log(responseData.error);
			this.toastr.error(responseData.error.message, 'Failed!');
	  }
	  
	);
	
	}
	
	// Signup free trial
	signupFreeTrial(model) {
		model.token = this._id;
		model._id = this._id;
		model.user_token = this.token;
		let responseData = <any>{};
		this.busy =  this.userService.getStripeToken(model).subscribe(
		   response => {
		   responseData = response;
			var sdata = {
				stripe_token : responseData.data.id,
				plan : model.plan,
				token : this._id,
				user_token : this.token,
				_id : this._id,
			}
			this.signupFreeTrialSubscribe(sdata);
		   },
		   error => {
			console.log(error);
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
		  }
		);
		
	}


	// Signup free trial subscribe
	signupFreeTrialSubscribe(data) {
	  let responseData = <any>{};
	  this.busy = this.userService.signupFreeTrialSubscribeApi(data).subscribe(
	   response => {
		 responseData = response;
		 this.toastr.success(responseData.message, 'Success!');
			 this.modal.confirm()
				.size('sm')
				.title('CasherPay')
				.body(`Freetrial Successfully activated in your account, Please logout and login again, click on 'Yes' to logout.`)
				.okBtn('Yes')
				.okBtnClass('btn btn-success')
				.cancelBtnClass('btn btn-warning')
			   .open()
				.then( (resultPromise) => {
					resultPromise.result.then( (result) => {
					this.localStorageService.removeData('currentUser');
					this.globalEventMangerService.showNavBar(false);
					this.router.navigate(['/login']);
				  }, 
				  () => {
				   console.log('Cancel');
				  } );
			  });
			
	   },
	   error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
	  }
	);
	}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/activefreetrial/activefreetrial.component.ts